import { render, staticRenderFns } from "./Create-Or-Update-Promotion.vue?vue&type=template&id=553068be&"
import script from "./Create-Or-Update-Promotion.vue?vue&type=script&lang=js&"
export * from "./Create-Or-Update-Promotion.vue?vue&type=script&lang=js&"
import style0 from "./Create-Or-Update-Promotion.vue?vue&type=style&index=0&id=553068be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports